import type { StaticLayerPayload } from "@config";
import type { ComponentType } from "react";
import { Array } from "./Array";
import { FullScreen } from "./Fullscreen";
import { Narrator } from "./Narrator";
import { PdfEntireSlideImage } from "./PdfEntireSlideImage";
import { SideBySide } from "./SideBySide";
import { Simple } from "./Simple";
import { Tabs } from "./Tabs";
import { Timeline } from "./Timeline";
import { Carousel } from "./carousel";

export const Combos: Record<string, ComponentType<StaticLayerPayload>> = {
  Array,
  Simple,
  FullScreen,
  SideBySide,
  VTimeline: Timeline,
  PdfEntireSlideImage,
  Tabs,
  Narrator,
  Carousel,
  Empty: () => null,
};
